import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
  getAuth,
  signOut,
} from "firebase/auth";
import { Device } from "@capacitor/device";
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';


const API_URL = import.meta.env.VITE_API_URL;
const auth = getAuth();

class AuthService {
  private googleProvider: GoogleAuthProvider;
  private appleProvider: OAuthProvider;
  private isNative: boolean | null = null;

  constructor() {
    // Inicializar proveedores
    this.googleProvider = new GoogleAuthProvider();
    this.googleProvider.addScope("profile");
    this.googleProvider.addScope("email");

    this.appleProvider = new OAuthProvider("apple.com");
    this.appleProvider.addScope("email");
    this.appleProvider.addScope("name");
  }

  private async checkPlatform() {
    if (this.isNative === null) {
      try {
        const info = await Device.getInfo();
        this.isNative = info.platform === "ios" || info.platform === "android";
      } catch {
        this.isNative = false;
      }
    }
    return this.isNative;
  }

  // Dentro de la clase AuthService, reemplazar el método actual por:

  async forgotPassword(email: string) {
    try {
      const response = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Something went wrong');
      }

      return data;
    } catch (error) {
      throw new Error(error instanceof Error ? error.message : 'Error al restablecer la contraseña');
    }
  }

  private async makeApiRequest(endpoint: string, data: any) {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async login(email: string, password: string) {
    try {
      const isNative = await this.checkPlatform();

      console.log('isNative', isNative);

      if (isNative) {
        const result = await FirebaseAuthentication.signInWithEmailAndPassword({
          email,
          password,
        });
        const { token: idToken } = await FirebaseAuthentication.getIdToken();

        return this.makeApiRequest("/api/auth/login", { idToken });
      } else {
        const result = await signInWithEmailAndPassword(auth, email, password);

        const token = await result.user.getIdToken();


        // const idToken = await result.user.getIdToken();

        // console.log('idToken', idToken);

        // const response = this.makeApiRequest("/api/auth/login", { idToken });

        // console.log('response', response);

        return result
      }
    } catch (error: any) {
      throw new Error(error.message || "Error al iniciar sesión");
    }
  }

  async loginWithGoogle() {
    try {
      const isNative = await this.checkPlatform();

      if (isNative) {
        const result = await FirebaseAuthentication.signInWithGoogle();
        const { token: idToken } = await FirebaseAuthentication.getIdToken();
        console.log(idToken);


        return this.makeApiRequest("/api/auth/google", { idToken });
      } else {
        return await this.webGoogleLogin();
      }
    } catch (error: any) {
      throw new Error(error.message || "Error al iniciar sesión con Google");
    }
  }

  async loginWithApple() {
    try {
      const isNative = await this.checkPlatform();

      if (isNative) {
        const result = await FirebaseAuthentication.signInWithApple();
        const { token: idToken } = await FirebaseAuthentication.getIdToken();
        return this.makeApiRequest("/api/auth/apple", { idToken });
      } else {
        return await this.webAppleLogin();
      }
    } catch (error: any) {
      throw new Error(error.message || "Error al iniciar sesión con Apple");
    }
  }

  async logout() {
    try {
      const isNative = await this.checkPlatform();

      if (isNative) {
        await FirebaseAuthentication.signOut();
      } else {
        await signOut(auth);
      }

      // // Llamar al endpoint de logout del backend
      // await fetch(`${API_URL}/api/auth/logout`, {
      //   method: "POST",
      //   credentials: "include",
      // });
    } catch (error: any) {
      console.error("Error during logout:", error);
      throw new Error(error.message || "Error al cerrar sesión");
    }
  }

  private async webGoogleLogin() {
    const result = await signInWithPopup(auth, this.googleProvider);
    const idToken = await result.user.getIdToken();
    return this.makeApiRequest("/api/auth/google", { idToken });
  }

  private async webAppleLogin() {
    const result = await signInWithPopup(auth, this.appleProvider);
    const idToken = await result.user.getIdToken();
    return this.makeApiRequest("/api/auth/apple", { idToken });
  }
}

// Crear y exportar una única instancia del servicio
export const authService = new AuthService();